import {
  Component,
  Injector,
  EventEmitter,
  Output,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forEach as _forEach, map as _map } from 'lodash-es';
import { AppComponentBase } from '@shared/app-component-base';
import {
  AnexarPrescricaoDto,
  ConsultaDto,
  ConsultaServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
  templateUrl: './anexar-prescricao-dialog.component.html',
  styleUrls: ['./anexar-prescricao-dialog.component.scss'],
})
export class AnexarPrescricaoDialogComponent extends AppComponentBase  {
  saving = false;
  consulta: ConsultaDto;
  prescricao: AnexarPrescricaoDto = null;
  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy

  ) {
    super(injector);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onCancel.emit();
  }

  handleUpload(event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    this.prescricao = new AnexarPrescricaoDto();
    this.prescricao.consultaId = this.consulta.id;
    this.prescricao.fileNameWithOutExtension = file.name;
    this.prescricao.tipoArquivo = file.type;
    this.prescricao.tamanhoArquivo = file.size;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.prescricao.base64File = reader.result.toString();
    };
  }


  save(): void {
    if (!this.prescricao) {
      return;
    }

    if (this.prescricao.base64File) {
      if (this.prescricao.tipoArquivo != '') {
        const splitFile = this.prescricao.fileNameWithOutExtension.split('.');
        this.prescricao.extension = splitFile[splitFile.length - 1];
        splitFile.pop();
        this.prescricao.fileNameWithOutExtension = splitFile.join('.');
      }

      this.saving = true;
      abp.ui.setBusy();
      this._consultaService
        .anexarPrescricao(this.prescricao)
        .pipe(
          finalize(() => {
            abp.ui.clearBusy();
          })
        )
        .subscribe((x) => {
          this.notify.info("Prescrição anexada com sucesso");
          this.bsModalRef.hide();
          this.onSave.emit();
        });

    }
  }
}



